import { useEffect } from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Layout } from "@components/Layout/index";
import { getPage, getModalSettings, getGlobalConfig } from "@lib/api/calls";
import TextSection from "@components/sections/TextSection";
import { trackEvent } from "@lib/track-event";
import styles from "@components/Typography/typography.module.css";
import helpStyles from "../styles/help.module.css";

export default function Help({ preview, title = "Help", seo, content, config, subscribed, modal }) {
  useEffect(() => {
    trackEvent("view_page", {
      pageTitle: title,
      pageCategory: "Information Page",
      pageLocation: window.location.href,
      pagePath: window.location.pathname,
    });
  }, []);
  return (
    <Layout
      config={config}
      title={title}
      seo={seo}
      subscribed={subscribed}
      isPreview={preview}
      modal={modal}
      pageFound={content}
    >
      <div className={helpStyles.headingWrapper}>
        <h1 className={styles.heading1}>{title}</h1>
      </div>
      <div className={helpStyles.textWrapper}>{content && <TextSection text={content} />}</div>
    </Layout>
  );
}

export async function getStaticProps({ locale, preview = false }) {
  const config = await getGlobalConfig(locale, preview);
  const modal = await getModalSettings(locale, preview);
  const helpPage = await getPage("help", locale, preview);

  const seo = {
    seoTitle: helpPage?.meta?.seoTitle || null,
    seoDescription: helpPage?.meta?.seoDescription || "",
    openGraphImage: helpPage?.meta?.openGraphImage || null,
    twitterCard: helpPage?.meta?.seoTwitterCardStyle || "summary_large_image",
  };

  return {
    props: {
      config,
      preview,
      title: helpPage?.title || "",
      seo,
      content: helpPage?.portableText || null,
      modal,
      ...(await serverSideTranslations(locale, ["common", "navbar", "footer", "cart"])),
    },
    revalidate: 1800,
  };
}
